/*
Login Form
*/

class LoginForm extends HTMLElement {
  constructor() {
    super();
    this.forgotPass();
  }
  forgotPass() {
    const loginForm = this.querySelector('.login-form');
    const recoverForm = this.querySelector('.recover-form');
    const recoverBtn = this.querySelector('.recover-button');
    const closeBtn = this.querySelector('.close-button');

    recoverBtn.addEventListener('click', () => {
      recoverForm.style.display = 'grid';
      loginForm.style.display = 'none';
    });
    closeBtn.addEventListener('click', () => {
      recoverForm.style.display = 'none';
      loginForm.style.display = 'grid';
    });
  }
}

customElements.define('login-form', LoginForm);

/*
Account Menu
*/

class AccountMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let currentUrl = window.location.href;
    const currentFragment = new URL(currentUrl).hash;
    if (currentFragment.substring(1) != '') {
      toggleSection(currentFragment.substring(1));
    }

    const buttons = this.querySelectorAll('[data-menu="button"]');
    buttons.forEach((button) => {
      const buttonURL = button.querySelector('a').href;
      const fragment = new URL(buttonURL).hash;
      const key = fragment.substring(1);

      if (currentFragment.substring(1) != '') {
        if (currentFragment.substring(1) === key) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      }

      button.addEventListener('click', () => {
        buttons.forEach((button) => {
          button.classList.remove('active');
        });
        button.classList.add('active');
        toggleSection(key);
      });
    });

    function toggleSection(key) {
      const sections = document.querySelectorAll('[data-element="screens-container"] > div');
      sections.forEach((section) => {
        if (section.dataset.id === key) {
          section.classList.remove('inactive');
        } else {
          section.classList.add('inactive');
        }
      });
    }
  }
}

customElements.define('account-menu', AccountMenu);

/*
Order Tabs
*/

class OrderTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = this.querySelector('div');
    const buttons = header.querySelectorAll('button');
    const content = this.querySelector('div:nth-child(2)');

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        buttons.forEach((button) => {
          button.classList.remove('border-black');
          button.classList.add('border-white');
        });
        button.classList.remove('border-white');
        button.classList.add('border-black');
        toggleScreen(index);
      });
    });

    function toggleScreen(index) {
      const screens = content.querySelectorAll('.w-full');
      screens.forEach((screen, i) => {
        if (index == i) {
          screen.classList.remove('hidden');
        } else {
          screen.classList.add('hidden');
        }
      });
    }
  }
}

customElements.define('order-tabs', OrderTabs);

/*
Switch Names
*/

class SwitchNames extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector('button');
    this.addEventListener('click', () => {
      if (button.innerHTML.trim() === this.dataset.active) {
        button.innerText = this.dataset.inactive;
      } else {
        button.innerHTML = this.dataset.active;
      }
    });
  }
}
customElements.define('switch-names', SwitchNames);

/*
Site Wishlist Link Generator
*/

class SiteWishlistLinkGenerator extends HTMLElement {
  connectedCallback() {
    this.customerId = this.dataset.customerId;
    const actionBtn = this.querySelector('button');

    this.addEventListener('click', async (e) => {
      const button = e.target.closest('button');
      const launchNewWindow = (link) => {
        const top = window.innerHeight / 2;
        const left = window.innerWidth / 1.75;
        window.open(
          link,
          '',
          `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600,top=${top},left=${left}`
        );
      };

      const wishlistLink = await this.getWishlistLink();

      if (button && button.matches('.copy-link')) {
        navigator.clipboard.writeText(wishlistLink).then(() => {
          button.innerHTML = 'Copied!';
          setTimeout(() => {
            button.innerHTML = 'Copy Link';
          }, 1500);
        });
      }

      if (button && button.matches('.facebook-link')) {
        const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${wishlistLink}`;
        launchNewWindow(fbUrl);
      }

      if (button && button.matches('.x-link')) {
        const twUrl = `https://twitter.com/intent/tweet?url=${wishlistLink}`;
        launchNewWindow(twUrl);
      }

      if (button && button.matches('.email-link')) {
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&body=${encodeURIComponent(wishlistLink)}`;
        window.open(gmailUrl, '_blank'); // Opens Gmail compose in a new tab
      }
    });
  }

  async getWishlistLink() {
    const res = await fetch(
      `https://beachriot-wishlist-app.vercel.app/api/beach-riot/wishlist/${this.customerId}/get-share-url`
    );
    const data = await res.json();
    return `${window.location.origin}/pages/wishlist?id=${encodeURIComponent(
      data.data.shareUrl.replace('/pages/wishlist?id=', '')
    )}`;
    navigator.clipboard.writeText();
  }
}

customElements.define('site-wishlist-link-generator', SiteWishlistLinkGenerator);

/*
Adresses Manager
*/

class Addresses extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const editBtn = this.querySelector('.edit-button');
    const editForm = document.querySelector('.edit-form');
    const addressesContainer = document.querySelector('.addresses-container');
    const cancelBtn = this.querySelector('.cancel-button');

    editBtn.addEventListener('click', () => {
      addressesContainer.classList.toggle('hidden');
      editForm.classList.toggle('hidden');
    });

    cancelBtn.addEventListener('click', () => {
      addressesContainer.classList.toggle('hidden');
      editForm.classList.toggle('hidden');
    });
  }
}

customElements.define('address-item', Addresses);

/*
Order History
*/

class OrderHistory extends HTMLElement {
  constructor() {
    super();
    this.openOrder();
  }

  openOrder() {
    const viewBtn = this.querySelector('.view-order');
    const orderContainer = this.querySelector('.order-container');
    viewBtn.addEventListener('click', () => {
      if (!viewBtn.classList.contains('active')) {
        viewBtn.classList.add('active');
        orderContainer.classList.remove('hidden');
        orderContainer.classList.remove('lg:hidden');
        setTimeout(() => {
          orderContainer.classList.remove('opacity-0');
        }, 100);
      } else {
        viewBtn.classList.remove('active');
        orderContainer.classList.add('opacity-0');
        setTimeout(() => {
          orderContainer.classList.add('hidden');
          orderContainer.classList.add('lg:hidden');
        }, 100);
      }
    });
  }
}
customElements.define('order-history', OrderHistory);
